import React from 'react';
import ReactDOM from 'react-dom';
import App from 'core/App';
import * as serviceWorker from './serviceWorker';
import './assets/fonts/fonts.css';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
